import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-view-pwc-schemes-button',
  templateUrl: './view-pwc-schemes-button.component.html',
  styleUrls: ['./view-pwc-schemes-button.component.css']
})
export class ViewPWcSchemesButtonComponent {
  public params: any;
  public parent: any;
  public disabled:boolean = false;
  public label: string = 'View';
  public field: string = '';
  public values: string[] = [];

  agInit(params: any): void {
    this.params = params;
    this.disabled=this.params.disabled;
    this.parent = params.context ? params.context : params.instance;
    this.setLabel(params.label);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  public onClick(): void {
    this.parent.onClickButton({
      rowNode: this.params.node,
      data : this.params.data,
      field: this.params.field
    });
  }

  public setLabel( label: string | undefined ): void {
    if( !label ) return;
    this.label = label;
  }

  public onMouseEnter(): void {
    if( !this.params ) return;

    const selectedSchemes: string[] = this.params.data.run.applicationSchemeData?.name.split(', ');

    if ( selectedSchemes )
      this.values = selectedSchemes;
  }
}
